import React from 'react';
import Icon from './Icon';

export default Icon(
  <g>
    <circle
      cx="8"
      cy="8"
      r="8"
    />
    <g transform="translate(-3.5 -3) scale(1.2)">
      <path fill="white" d="M7.492,8.224,6.464,9.246l2.565,2.565,4.1-4.1L12.108,6.688,9.036,9.76Z" />
    </g>
  </g>,
  '0 0 16 16', 'BadgeSuccessIcon',
);
